import { createBrowserRouter } from "react-router-dom"
import { routesArray } from "./routesArray"
export const router = createBrowserRouter(routesArray)
